<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="softInfo.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="softInfo"
          :rules="ruleValidate"
          class="form"
          label-width="90px">
<!--        <el-form-item label="软件号" prop="softNo">-->
<!--          <el-input :disabled="softInfo.pkid > 0" v-model.trim="softInfo.softNo" placeholder="请输入"/>-->
<!--        </el-form-item>-->
        <el-form-item label="程序名" prop="programNo">
          <el-input :disabled="softInfo.pkid > 0" v-model.trim="softInfo.programNo" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="波特率(K)" prop="baudRate">
          <div style="display: flex;flex-direction: row;">
            <el-select v-model="softInfo.baudRate" placeholder="请选择">
              <el-option label="25" :value="25"/>
              <el-option label="100" :value="100"/>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="扩展帧" prop="extFlag">
          <div style="display: flex;flex-direction: row;">
            <el-select v-model="softInfo.extFlag" placeholder="请选择">
              <el-option label="否" :value="0"/>
              <el-option label="是" :value="1"/>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="发送ID(0x)" prop="sendId">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model.trim="softInfo.sendId" placeholder="请输入"/>
          </div>
        </el-form-item>
        <el-form-item label="发送字节(0x)" prop="sendByte">
          <div>
            <el-radio-group v-model="sendType" @input="changeType()">
              <el-radio label="1">模式1</el-radio>
              <el-radio label="2">模式2</el-radio>
              <el-radio label="0">其它</el-radio>
            </el-radio-group>

            <div style="display: flex;flex-direction: row;">
              <el-input v-model.trim="softInfo.value1"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value2"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value3"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value4"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value5"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value6"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value7"/>
              <span>-</span>
              <el-input v-model.trim="softInfo.value8"/>
            </div>
          </div>

        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="softInfo.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name: "EditEIDSetting",
    components: {},
    data() {
      return {
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        sendType: "1",
        softInfo: {
          pkid: 0,
          softNo: "",
          programNo: "",
          baudRate: "25",
          sendId: "0",
          extFlag: 0,
          note: "",
          sendByte: "",
          value1: "0C",
          value2: "0",
          value3: "E4",
          value4: "0",
          value5: "0",
          value6: "0",
          value7: "0",
          value8: "0",
        },
        ruleValidate: {
          // softNo: {required: true, message: "不能为空", trigger: "blur"},
          programNo: {required: true, message: "不能为空", trigger: "blur"},
          sendId: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.softInfo.pkid = row.pkid;
        this.dialogVisible = true;
        if (this.softInfo.pkid > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http
            .get("basic", `baseSoftinfoes/${this.softInfo.pkid}`)
            .then(resp => {
              this.softInfo = resp;
            });
      },

      changeType() {
        if (this.sendType == "1") {
          this.softInfo.value1 = "0C";
          this.softInfo.value2 = "0";
          this.softInfo.value3 = "E4";
          this.softInfo.value4 = "0";
          this.softInfo.value5 = "0";
          this.softInfo.value6 = "0";
          this.softInfo.value7 = "0";
          this.softInfo.value8 = "0";
        } else if (this.sendType == "2") {
          this.softInfo.value1 = "E4";
          this.softInfo.value2 = "0";
          this.softInfo.value3 = "0";
          this.softInfo.value4 = "0";
          this.softInfo.value5 = "0";
          this.softInfo.value6 = "0";
          this.softInfo.value7 = "0";
          this.softInfo.value8 = "0";
        } else {
          this.softInfo.value1 = "0";
          this.softInfo.value2 = "0";
          this.softInfo.value3 = "0";
          this.softInfo.value4 = "0";
          this.softInfo.value5 = "0";
          this.softInfo.value6 = "0";
          this.softInfo.value7 = "0";
          this.softInfo.value8 = "0";
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.softInfo.pkid > 0) {
              this.$http
                  .put("basic", "baseSoftinfoes", this.softInfo)
                  .then(() => {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
            } else {
              this.$http
                  .post("basic", "baseSoftinfoes", this.softInfo)
                  .then(() => {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
